"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _fileSaver = _interopRequireDefault(require("file-saver"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Handles file utilities.
 */
var FileUtility = /*#__PURE__*/function () {
  function FileUtility() {
    _classCallCheck(this, FileUtility);
  }

  _createClass(FileUtility, null, [{
    key: "saveAsJson",

    /**
     * Saves data as JSON to a file.
     *
     * @param {string} filename Filename to use.
     * @param {object} data Data to export.
     */
    value: function saveAsJson(filename, data) {
      var blob = new Blob([JSON.stringify(data, null, 4)], {
        type: 'application/json; charset=utf-8'
      });
      this.saveAs(filename, blob);
    }
    /**
     * Saves data as any file type.
     *
     * @param {string} filename Filename to use.
     * @param {object} blob Blob object.
     */

  }, {
    key: "saveAs",
    value: function saveAs(filename, blob) {
      _fileSaver.default.saveAs(blob, filename);
    }
    /**
     * Opens a file dialog and returns the file buffer result.
     *
     * @example FileSaver.openFileDialog().then(result => {  }).catch(error => {  });
     * @param {string} type File type to open.
     * @param {boolean} [readAsText] TRUE to read the data as text. Default is FALSE.
     * @returns {Promise} Promise object.
     */

  }, {
    key: "openFileDialog",
    value: function openFileDialog(type) {
      var readAsText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return new Promise(function (resolve, reject) {
        var label;
        var input = document.createElement('input'); //Fix for IE - It will trick IE to open the dialog if standard input.click() does not work

        var ieTimeout = setTimeout(function () {
          input.id = 'file_input';
          label = document.createElement('label');
          label.setAttribute('for', 'file_input');
          label.click();
          document.body.appendChild(label);
        }, 100);
        input.style.cssText = 'position:absolute;left:0;top:-999rem;';
        input.type = 'file';
        input.setAttribute('accept', '.' + type);
        input.addEventListener('change', function (event) {
          var files = event.target.files;
          clearTimeout(ieTimeout);

          if (files && files.length > 0) {
            var file = files[0];

            if (file.name.endsWith(type)) {
              var reader = new FileReader();

              reader.onload = function (event) {
                resolve(event.target.result || null);
              };

              if (readAsText) {
                reader.readAsText(file);
              } else {
                reader.readAsDataURL(file);
              }
            } else {
              reject(new Error('The file is not of type ' + type + '. Please select a file with valid type.'));
            }
          } else {
            resolve(null);
          }

          document.body.removeChild(input);

          if (label) {
            document.body.removeChild(label);
          }
        });
        document.body.appendChild(input);
        input.click();
        setTimeout(function () {
          input.focus();
          input.blur();
        }, 0);
      });
    }
  }]);

  return FileUtility;
}();

exports.default = FileUtility;